import { httpDelete, httpGet, httpPatch, httpPost } from "../connection";
import {
  createCocRecord,
  deleteCocRecord,
  getCocMoveReasons,
  getCocRecords,
  updateCocRecord,
} from "./coc";
import EvidencePhotoAPI, {
  deleteEvidencePhotos,
  getEvidencePhotos,
  uploadEvidencePhotos,
} from "./photos";
export * from "./coc";
export * from "./photos";

export async function getEvidence(options = {}) {
  const { data_only = true, ...rest } = options;
  if (data_only) {
    return (await httpGet("/evidence", rest))?.data || [];
  }

  return await httpGet("/evidence", rest);
}

async function query(query = {}) {
  return await httpPost("/evidence/query", query);
}

async function exportEvidenceList(query = {}) {
  return await httpPost("/evidence/export", query);
}

/**
 * @param {Record<string, unknown>} values
 * @param {{ is_parent?: number, parent_name?: string | null, parent_id?: number | null }} [options]
 *   Parent linkage. Defaults to a top-level (parent) item; pass
 *   `{ is_parent: 0, parent_id, parent_name }` to create a child item.
 */
export async function createEvidence(
  values,
  options = { is_parent: 1, parent_name: null, parent_id: null }
) {
  values.is_parent = options.is_parent;
  values.parent_name = options.parent_name;
  values.parent_id = options.parent_id;

  return await httpPost(`/evidence`, values);
}

export async function updateEvidence(id, values) {
  return await httpPatch(`/evidence/${id}`, values);
}

export async function deleteEvidence(options) {
  return await httpDelete(`/evidence/${options.evidence_id}`);
}

export async function createIntakeDetails(values = {}) {
  return await httpPost(
    `/evidence/${values.evidence_id}/coc/intake-details`,
    values
  );
}

export async function getEvidenceSubmitters() {
  return await httpGet(`/evidence/submitters`);
}

export async function getEvidenceBrands() {
  return await httpGet(`/evidence/brands`);
}

export async function getEvidenceMeta() {
  return await httpGet(`/evidence/meta`);
}

export async function getEvidenceFieldData(query) {
  return await httpGet(`/evidence/fieldData`, query);
}

export async function getEvidenceNumberFormat() {
  return await httpGet(`/evidence/format`);
}

export async function updateEvidenceNumberFormat(values) {
  return await httpPatch(`/evidence/format`, values);
}

async function evidenceNumberExists(values) {
  const result = await httpGet(`/evidence/evidence-numbers`, values);

  if (!result) return false;
  return result?.length > 0;
}

const EvidenceAPI = {
  query,
  getEvidence,
  createEvidence,
  updateEvidence,
  deleteEvidence,
  exportEvidenceList,
  getEvidenceBrands,
  getCocRecords: getCocRecords,
  getEvidencePhotos: getEvidencePhotos,
  uploadEvidencePhotos: uploadEvidencePhotos,
  getCocMoveReasons: getCocMoveReasons,
  createCocRecord: createCocRecord,
  createIntakeDetails: createIntakeDetails,
  getFieldData: getEvidenceFieldData,
  updateCocRecord: updateCocRecord,
  deleteCocRecord: deleteCocRecord,
  deleteEvidencePhoto: deleteEvidencePhotos,
  EvidencePhotos: EvidencePhotoAPI,
  evidenceNumberExists,
};

export default EvidenceAPI;
